import { call } from "./api";
import { getCredentials } from "./session";
import * as AWS from "aws-sdk";
import config from "../config/app";
import * as Cognito from 'amazon-cognito-identity-js';

const loginChallenge = (username, password) => {

  const cognitoUser = new Cognito.CognitoUser({
      Username: username,
      Pool: new Cognito.CognitoUserPool({
          UserPoolId: config.aws.cognito.UserPoolId,
          ClientId: config.aws.cognito.ClientId
      })
  });

  return new Promise((resolve, reject) => {
      const authConfig = {
          onSuccess(result) {
              resolve(result);
          },
          onFailure(err) {
              reject(err);
          },
          newPasswordRequired(userAttributes, requiredAttributes) {
              cognitoUser.completeNewPasswordChallenge(password, {}, authConfig);
          }
      };

      cognitoUser.authenticateUser(new Cognito.AuthenticationDetails({
          Username: username,
          Password: password
      }), authConfig);
  });
};

export const count = () => {
    return call(client => {
        return client.get(`/users/count`);
    });
};

export const all = () => {
    return call(client => {
        return client.get(`/users`, {
            params: { count: 0 }
        });
    });
};

export function search(params) {
    return call(client => {
        return client.get(`/users`, params)
    });
}

export function searchByUser(params) {
    return call(client => {
        return client.get(`/users/contents`, params)
    });
}

export const add = params => {
    const postUser = client => {
        return client.post(`/users`, params);
    };

    let id;
    return new Promise((resolve, reject) => {
        call(postUser)
            .then(response => {
                id = response.data.id;
                return getCredentials();
            })
            .then(credentials => {
                const provider = new AWS.CognitoIdentityServiceProvider({
                    credentials: credentials,
                    region: config.aws.region
                });
                return provider
            })
            .then(provider => {
                return provider.adminCreateUser({
                    UserPoolId: config.aws.cognito.UserPoolId,
                    Username: params.username,
                    TemporaryPassword: params.password,
                    UserAttributes: [
                        {
                            Name: "email",
                            Value: params.email,
                        }
                    ]
                }).promise()
            })
            .then(() => {
                // Cognito期限を廃止するため1回ログイン（パスワード変更もどきまで行う）
                return loginChallenge(params.username, params.password);
            })
            .then(() => {
                resolve();
            })
            .catch(err => {
                call(client => {
                    client.delete(`/users/${id}`, {});
                })
                reject(err);
            })
    });
};

export const edit = (id, params) => {
    return call(client => {
        return client.put(`/users/${id}`, params);
    });
};

export const remove = (params) => {
    const deleteUser = client => {
        return client.delete(`/users/${params.id}`, params);
    };

    return getCredentials()
        .then(credentials => {
            const provider = new AWS.CognitoIdentityServiceProvider({
                credentials: credentials,
                region: config.aws.region
            });

            return provider
                .adminDeleteUser({
                    UserPoolId: config.aws.cognito.UserPoolId,
                    Username: params.username,
                })
                .promise();
        })
        .then(response => {
            console.log(response);
            return call(deleteUser);
        })
        .catch(err => console.log(err));
};

export const batchRemove = (params) => {
    const promises = params.map(param => {
        return remove(param);
    });

    return Promise.all(promises);
};



// WEBPACK FOOTER //
// ./src/api/user.js